import { render, staticRenderFns } from "./NewApplicationCard.vue?vue&type=template&id=0b972720&scoped=true&"
import script from "./NewApplicationCard.vue?vue&type=script&lang=js&"
export * from "./NewApplicationCard.vue?vue&type=script&lang=js&"
import style0 from "./NewApplicationCard.vue?vue&type=style&index=0&id=0b972720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b972720",
  null
  
)

export default component.exports